import { HStack, Image, Text } from "@chakra-ui/react";
import { interpretBoldTags } from "../../../utils/processPaywallText";
import { SubscriptionNoteType } from "../types";

export function SubscriptionNote({
  subscriptionNote,
}: {
  subscriptionNote: SubscriptionNoteType;
}) {
  const noteText = interpretBoldTags(subscriptionNote.text);
  return (
    <HStack
      gap={2}
      p={4}
      background={subscriptionNote.background_color ?? "rgba(50,131,186,0.1)"}
      border="1px solid"
      borderColor={subscriptionNote.border_color ?? "rgba(50,131,186,0.4)"}
      borderRadius="8px"
      alignItems="start"
    >
      <Image
        src={subscriptionNote.icon_url}
        boxSize={6}
        alt={subscriptionNote.text}
      />
      <Text
        variant="paymentSubscriptionNote"
        dangerouslySetInnerHTML={{ __html: noteText }}
      />
    </HStack>
  );
}
